// Fallback blog data for when API is unavailable
// This provides sample content so the blog page doesn't break

export const fallbackBlogs = [
  {
    _id: 'fallback-1',
    id: 'fallback-1',
    title: 'Top 10 Road Trip Destinations in Western Australia',
    slug: 'top-10-road-trip-destinations-western-australia',
    excerpt: 'Discover the most breathtaking road trip destinations in Western Australia, from pristine beaches to ancient forests.',
    summary: 'Discover the most breathtaking road trip destinations in Western Australia, from pristine beaches to ancient forests.',
    content: '<h2>Explore Western Australia</h2><p>Western Australia offers some of the most stunning road trip destinations in the world. From the turquoise waters of the Coral Coast to the ancient landscapes of the Kimberley, there\'s something for every traveler.</p><h3>1. Margaret River</h3><p>Famous for its wineries, surf beaches, and gourmet food scene.</p><h3>2. Ningaloo Reef</h3><p>Swim with whale sharks and explore pristine coral reefs.</p><h3>3. The Pinnacles</h3><p>Ancient limestone formations in Nambung National Park.</p>',
    featuredImage: '/img/blog/road-trip.jpg',
    image: '/img/blog/road-trip.jpg',
    category: 'travel',
    categories: [{ name: 'Travel', slug: 'travel' }],
    tags: ['road trip', 'western australia', 'travel guide'],
    author: { name: 'TAK8 Team' },
    publishDate: '2025-12-15T00:00:00.000Z',
    createdAt: '2025-12-15T00:00:00.000Z',
    readingTime: 8,
    readTime: 8,
    status: 'published'
  },
  {
    _id: 'fallback-2',
    id: 'fallback-2',
    title: 'Essential Car Rental Tips for First-Time Renters',
    slug: 'essential-car-rental-tips-first-time-renters',
    excerpt: 'Everything you need to know before renting a car for the first time, from insurance options to fuel policies.',
    summary: 'Everything you need to know before renting a car for the first time, from insurance options to fuel policies.',
    content: '<h2>Your First Car Rental</h2><p>Renting a car for the first time can be overwhelming. Here are our top tips to make the process smooth and stress-free.</p><h3>Understanding Insurance</h3><p>Learn about the different insurance options available and what coverage you really need.</p><h3>Fuel Policies</h3><p>Full-to-full vs prepaid fuel - which option is best for you?</p><h3>Inspection Tips</h3><p>Always document the car\'s condition before driving off.</p>',
    featuredImage: '/img/blog/car-rental-tips.jpg',
    image: '/img/blog/car-rental-tips.jpg',
    category: 'tips',
    categories: [{ name: 'Tips', slug: 'tips' }],
    tags: ['car rental', 'tips', 'first time'],
    author: { name: 'TAK8 Team' },
    publishDate: '2025-12-10T00:00:00.000Z',
    createdAt: '2025-12-10T00:00:00.000Z',
    readingTime: 6,
    readTime: 6,
    status: 'published'
  },
  {
    _id: 'fallback-3',
    id: 'fallback-3',
    title: 'Perth Airport Car Rental Guide',
    slug: 'perth-airport-car-rental-guide',
    excerpt: 'Complete guide to renting a car at Perth Airport, including terminal locations and shuttle services.',
    summary: 'Complete guide to renting a car at Perth Airport, including terminal locations and shuttle services.',
    content: '<h2>Renting at Perth Airport</h2><p>Perth Airport has multiple terminals and car rental options. Here\'s everything you need to know.</p><h3>Terminal Locations</h3><p>T1 and T2 are the main domestic terminals, while T1 also handles international flights.</p><h3>Car Rental Desks</h3><p>Most major car rental companies have desks in the arrivals area.</p><h3>Shuttle Services</h3><p>Free shuttles connect terminals to off-site rental locations.</p>',
    featuredImage: '/img/blog/perth-airport.jpg',
    image: '/img/blog/perth-airport.jpg',
    category: 'guides',
    categories: [{ name: 'Guides', slug: 'guides' }],
    tags: ['perth airport', 'car rental', 'guide'],
    author: { name: 'TAK8 Team' },
    publishDate: '2025-12-05T00:00:00.000Z',
    createdAt: '2025-12-05T00:00:00.000Z',
    readingTime: 5,
    readTime: 5,
    status: 'published'
  }
];

export default fallbackBlogs;
